import React, { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Col, 
  Container, 
  Row, 
  Form,
} from 'react-bootstrap';
import { Button, ButtonGroup } from '@/shared/components/Button';
import {
   Card, CardBody, CardTitleWrap, CardTitle, CardSubhead,
} from '@/shared/components/Card';
import { Table } from '@/shared/components/TableElements';
import { FaExclamationCircle } from 'react-icons/fa';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Mealcontext } from '../../../../../context/MealContext';
import RequestShort from './RequestShort';
import ProgressBar from '../../../Loader';
import { AuthContext } from '../../../../../context/AuthContext';
import { GlobalVarContext } from '../../../../../context/GlobalVarContext';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';

const RequestList = () => {
  const [request, setRequest] = useState([]);
  const [filterRequest, setFilterRequest] = useState([]);
  const [isLoading, setIsLoading] = useState(true); 
  const [errors, setError] = useState(null); 
  const { refresh } = useContext(Mealcontext);
  const { apiGlobal } = useContext(GlobalVarContext);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const { restaurantid } = useContext(AuthContext);
  const [searchQuery, setSearchQuery] = useState('');

  const fetchData = async () => {
    setIsLoading(true);

    const formdata = new FormData();
    formdata.append('restaurant_id', restaurantid);
    try {
      const response = await fetch(`${apiGlobal}restaurant/meal_pending_list.php`, {
        method: 'POST',
        body: formdata,
      });
      const data = await response.json();
      // console.log(data);
      if (data.status && data.message === 'Success') {
        setRequest(data.data);
        setFilterRequest(data.data);
        // console.log(data.data);
      } else {
        setRequest([]);
        setFilterRequest([]);
      }
    } catch (error) {
      setError('Failed to load data. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
  
    if (query) {
      const filteredData = request
      .filter(requestdata => requestdata.name.toLowerCase().includes(query.toLowerCase()));
      setFilterRequest(filteredData); // Update filtered data only
    } else {
      setFilterRequest(request); // Reset to full list
    }
  };

  useEffect(() => {
    fetchData();
  }, [refresh, sideBarRefresh?.restaurantMealRequestRefresh]);

  const refreshHandler = () => {
    fetchData();
    setSearchQuery('');
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          // justifyContent: 'center', // Center horizontally
          // alignItems: 'center', // Center vertically
          height: '100vh', // Full viewport height
        }}
      >
        <ProgressBar />
      </div>
    );
  }

  if (errors) {
    return <div>{errors}</div>;
  }

  return (
    <div>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
      marginBottom: '5px',
    }}
      >
        <Typography sx={{ color: 'text.primary' }}>Restaurant</Typography>
        <Typography sx={{ color: 'text.primary' }}>Meal</Typography>
        <Typography sx={{ color: 'text.primary' }}>Request</Typography>
      </Breadcrumbs>
      <Container className="bg-white" style={{ padding: '20px' }}>
     
        <div style={{
                     display: 'flex', width: '25%', marginBottom: '10px', marginTop: '10px', alignItems: 'center',
                   }}
        >
          <Form.Control
            type="text"
            placeholder="Search by Name......"
            value={searchQuery}
            onChange={handleSearch}
            style={{
                         height: '30px',
                         marginTop: '5px',
                         borderColor: 'green',
                         flexGrow: 1,
                       }}
          />
  
          <ButtonGroup icons dir="ltr" style={{ marginTop: '10px' }}>
            <Button
              variant="outline-secondary"
              title="Refresh"
              size="sm"
              style={{ marginLeft: '10px' }}
              onClick={refreshHandler}
            >
              <span className="lnr lnr-sync" />
            </Button>
          </ButtonGroup>
        
        </div>
    
        <Row>
          {filterRequest.length > 0 ? (
 filterRequest.map((req, index) => (
   <RequestShort 
     key={req.id} 
     index={index} 
     date={req.created_date_time} 
     name={req.name} 
     id={req.id} 
     logo={req.photo}             
   />
 ))
) : (
                 // If search results are empty
  <div style={{
                   textAlign: 'center',
       padding: '50px',
       backgroundColor: '#f8d7da',
       borderRadius: '8px',
       marginTop: '20px',
                   color: '#721c24',
       fontSize: '16px',
                 }}
  >
    <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
    <p>{searchQuery ? 'No results found for your search' : 'No requests available'}</p>
  </div>
               )}
        </Row>
      </Container>
    </div>
    
  );
};


export default RequestList;
